import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/drone/src/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/drone/src/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { DateVector } from './DateVector';
import { DATE_PICKER_INFINITY } from '../constants';
/**
 * @internal
 */
export var DateVectorRange = /*#__PURE__*/function () {
  function DateVectorRange() {
    var dateStart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var dateEnd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    _classCallCheck(this, DateVectorRange);
    this.dateStart = dateStart;
    this.dateEnd = dateEnd;
  }
  _createClass(DateVectorRange, [{
    key: "clone",
    value: function clone() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        dateStart = _ref.dateStart,
        dateEnd = _ref.dateEnd;
      var ownDateStart = this.dateStart,
        ownDateEnd = this.dateEnd;
      var effectiveDateStart = dateStart || ownDateStart || DATE_PICKER_INFINITY;
      var effectiveDateEnd = dateEnd || ownDateEnd || DATE_PICKER_INFINITY;
      return new DateVectorRange(effectiveDateStart ? effectiveDateStart.clone() : DATE_PICKER_INFINITY, effectiveDateEnd ? effectiveDateEnd.clone() : DATE_PICKER_INFINITY);
    }
  }, {
    key: "convertToLocalDateRange",
    value: function convertToLocalDateRange(timeVector) {
      var dateStart = this.dateStart,
        dateEnd = this.dateEnd;
      var time = {};
      if (timeVector) {
        time = {
          hour: timeVector.hour,
          minute: timeVector.minute
        };
      }
      var start;
      if (dateStart) {
        start = dateStart.clone(time).convertToLocalDate();
      }
      var end;
      if (dateEnd) {
        end = dateEnd.clone(time).convertToLocalDate();
      }
      return [start, end];
    }
  }, {
    key: "convertToLocalDate",
    value: function convertToLocalDate(timeVector) {
      var dateStart = this.dateStart;
      var time = {};
      if (timeVector) {
        time = {
          hour: timeVector.hour,
          minute: timeVector.minute
        };
      }
      var start;
      if (dateStart) {
        start = dateStart.clone(time).convertToLocalDate();
      }
      return start;
    }
  }, {
    key: "isInfinite",
    value: function isInfinite() {
      return this.isInfiniteStart() || this.isInfiniteEnd();
    }
  }, {
    key: "isInfiniteStart",
    value: function isInfiniteStart() {
      return !this.dateStart;
    }
  }, {
    key: "isInfiniteEnd",
    value: function isInfiniteEnd() {
      return !this.dateEnd;
    }
  }, {
    key: "isFlat",
    value: function isFlat() {
      var _a;
      return !!((_a = this.dateEnd) === null || _a === void 0 ? void 0 : _a.isEqualTo(this.dateStart));
    }
  }, {
    key: "isIllegal",
    value: function isIllegal() {
      if (!this.dateStart || !this.dateEnd) {
        return false;
      }
      return this.dateEnd.isSmallerThanOrEqual(this.dateStart);
    }
  }, {
    key: "contains",
    value: function contains(date) {
      if (this.isInfiniteStart()) {
        return date.isSmallerThanOrEqual(this.dateEnd);
      }
      if (this.isInfiniteEnd()) {
        return date.isGreaterThanOrEqual(this.dateStart);
      }
      return date.isGreaterThanOrEqual(this.dateStart) && date.isSmallerThanOrEqual(this.dateEnd);
    }
  }, {
    key: "toString",
    value: function toString() {
      var _a, _b, _c, _d;
      return "[".concat((_b = (_a = this.dateStart) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '∞', ", ").concat((_d = (_c = this.dateEnd) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : '∞', "]");
    }
  }], [{
    key: "createFromLocalDateRange",
    value: function createFromLocalDateRange(dateRange) {
      if (!dateRange) {
        return new this();
      }
      return new this(dateRange[0] ? DateVector.createFromLocalDate(dateRange[0]) : DATE_PICKER_INFINITY, dateRange[1] ? DateVector.createFromLocalDate(dateRange[1]) : DATE_PICKER_INFINITY);
    }
  }, {
    key: "createFromLocalDate",
    value: function createFromLocalDate(date) {
      if (!date) {
        return new this();
      }
      return new this(date ? DateVector.createFromLocalDate(date) : DATE_PICKER_INFINITY, date ? DateVector.createFromLocalDate(date) : DATE_PICKER_INFINITY);
    }
    /**
     * @internal
     * @param dateRange
     * @param currentDateVector
     */
  }, {
    key: "createFromLocalDateAdvancedRange",
    value: function createFromLocalDateAdvancedRange(dateRange, currentDateVector) {
      var _dateRange = _slicedToArray(dateRange, 2),
        left = _dateRange[0],
        right = _dateRange[1];
      return new this(this.createLocalDateAdvancedRangeEdge(left, currentDateVector), this.createLocalDateAdvancedRangeEdge(right, currentDateVector));
    }
  }, {
    key: "createLocalDateAdvancedRangeEdge",
    value: function createLocalDateAdvancedRangeEdge(dateEdge, currentDateVector) {
      if (dateEdge === null) {
        return DATE_PICKER_INFINITY;
      }
      if (dateEdge instanceof Date) {
        return DateVector.createFromLocalDate(dateEdge);
      }
      // string otherwise
      var result = DateVector.createFromMetaString(dateEdge, {
        currentDateVector: currentDateVector
      });
      if (result) {
        return result;
      }
      return DATE_PICKER_INFINITY;
    }
  }]);
  return DateVectorRange;
}();